import createClient from 'openapi-fetch'
import {HttpError} from '@freckle/educator-entities/ts/common/exceptions/http-error'
import {PATHS} from '@freckle/educator-entities/ts/common/helpers/paths'
import {paths, operations as ops} from '@freckle/educator-entities/ts/fancy-api/generated-client'

export {HttpError} from '@freckle/educator-entities/ts/common/exceptions/http-error'

export type operations = ops

export const client = createClient<paths>({
  baseUrl: PATHS.unversionedAPIUrl,
  credentials: 'include',
})

export type Ok<
  Op extends {responses: {200: {content: {'application/json': T}}}},
  T = Op['responses'][200]['content']['application/json'],
> = T

export function ensureOk<Response extends {ok: boolean}>({
  response,
}: {
  response: Response
}): Promise<void> {
  if (!response.ok) return Promise.reject(new HttpError(response))

  return Promise.resolve()
}

export function handleDataOrError<T = unknown>({
  response,
  data,
}: {
  data?: T
  response: Response
}): T | Promise<never> {
  return response.ok && data !== undefined ? data : Promise.reject(new HttpError(response))
}
